import { styled } from '@mui/styles'
import { Box } from '@mui/material'

export const ModalContainer = styled(Box)({
  position: 'absolute',
  zIndex: 1,
  bottom: 160,
  left: 24,
})

